import React from 'react';
import { useParams } from 'react-router-dom';
import GRSThirteenNine from '../../../Wagons/GRS wagons/GRSThirteenNine/GRSThirteenNine';
import GRSElevenOne from '../../../Wagons/GRS wagons/GRSElevenOne/GRSElevenOne';
import GRTOne from '../../../Wagons/GRT wagons/GRTOne/GRTOne';
import GRTTwo from '../../../Wagons/GRT wagons/GRTTwo/GRTTwo';
import GRTOneFour from '../../../Wagons/GRT wagons/GRTOneFour/GRTOneFour';
import GRTFour from '../../../Wagons/GRT wagons/GRTFour/GRTFour';
import GRTTwoFour from '../../../Wagons/GRT wagons/GRTTwoFour/GRTTwoFour';
import VMKTwoThree from '../../../Wagons/VMK wagons/VMKTwoThree/VMKTwoThree';
import GRTThree from '../../../Wagons/GRT wagons/GRTThree/GRTThree';
import ARMLux from '../../../Wagons/ARM wagons/ARMLux/ARMlux';
import MapImageEighteen from '../../../Wagons/mapImageWagons/mapImageEighteen/MapImageEighteen';
import MapImageHundred from '../../../Wagons/mapImageWagons/mapImageHundred/MapImageHundred';
import MapImageNineteen from '../../../Wagons/mapImageWagons/mapImageNineteen/MapImageNineteen';
import { TicketBookingProvider } from '../../../contexts/ticketBookingContext/TicketBookingContext';
import MapImageSixty from '../../../Wagons/mapImageWagons/mapImageSixty/MapImageSixty';
import MapImageSixtyOne from '../../../Wagons/mapImageWagons/mapImageSixtyOne/MapImageSixtyOne';
import MapImageSixtyTwo from '../../../Wagons/mapImageWagons/mapImageSixtyTwo/MapImageSixtyTwo';
import MapImageSixtyThree from '../../../Wagons/mapImageWagons/mapImageSixtyThree/MapImageSixtyThree';
import MapImageSixtyFour from '../../../Wagons/mapImageWagons/mapImageSixtyFour/MapImageSixtyFour';
import MapImageTwo from '../../../Wagons/mapImageWagons/mapImageTwo/MapImageTwo';
import MapImageOne from '../../../Wagons/mapImageWagons/mapImageOne/MapImageOne';
import MapImageThree from '../../../Wagons/mapImageWagons/mapImageThree/MapImageThree';
import MapImageSixtySix from '../../../Wagons/mapImageWagons/mapImageSixtySix/MapImageSixtySix';
import MapImageEleven from '../../../Wagons/mapImageWagons/mapImageEleven/MapImageEleven';
import MapImageSixtyFive from '../../../Wagons/mapImageWagons/mapImageSixtyFive/MapImageSixtyFive';
import MapImageTwelve from '../../../Wagons/mapImageWagons/mapImageTwelve/MapImageTwelve';
import MapImageThirteen from '../../../Wagons/mapImageWagons/mapImageThirteen/MapImageThirteen';
import MapImageSeventeen from '../../../Wagons/mapImageWagons/mapImageSeventeen/MapImageSeventeen';
import MapImageFifteen from '../../../Wagons/mapImageWagons/mapImageFifteen/MapImageFifteen';
import MapImageFourteen from '../../../Wagons/mapImageWagons/mapImageFourteen/MapImageFourteen';
import DesktopWatcher from '../../../Wagons/DesktopWatcher';
import MapImageSixtyEight from '../../../Wagons/mapImageWagons/mapImageSixtyEight/MapImageSixtyEight';
import MapImageSixtyNine from '../../../Wagons/mapImageWagons/mapImageSixtyNine/MapImageSixtyNine';
import MapImageSeventy from '../../../Wagons/mapImageWagons/mapImageSeventy/MapImageSeventy';
import MapImageSeventyOne from '../../../Wagons/mapImageWagons/mapImageSeventyOne/MapImageSeventyOne';

const wagonComponents = {
  0: GRSThirteenNine,
  1: MapImageOne, // done
  2: MapImageTwo, // done
  3: MapImageThree, // done
  4: GRSElevenOne,
  5: GRTOne, // done
  6: GRTTwo, // done
  7: GRTOneFour,
  8: GRTTwoFour, // done
  9: GRTFour, // done
  10: VMKTwoThree,
  11: MapImageEleven, // done
  12: MapImageTwelve, // done
  13: MapImageThirteen, // done
  14: MapImageFourteen, // done
  15: MapImageFifteen, // done
  16: GRTThree,
  17: MapImageSeventeen, // done
  18: MapImageEighteen, // done
  19: MapImageNineteen, // done
  60: MapImageSixty, // done
  61: MapImageSixtyOne, // done
  62: MapImageSixtyTwo, // done
  63: MapImageSixtyThree, // done
  64: MapImageSixtyFour, // done
  65: MapImageSixtyFive, // done
  66: MapImageSixtySix, // done
  67: ARMLux,
  68: MapImageSixtyEight,
  69: MapImageSixtyNine,
  70: MapImageSeventy,
  71: MapImageSeventyOne,
  100: MapImageHundred, // done
};

function Wagons() {
  const { id } = useParams();
  const Wagon = wagonComponents[id];
  return (

    <TicketBookingProvider bookingData={{
      departure: {
        chosenAvailableSeatsClasses: [{ seatClass: { id: 1 } }],
      },
    }}
    >
      <DesktopWatcher />
      <div className="py-10 flex items-center justify-center">
        <div className="train">
          {
        Wagon ? (
          <Wagon
            carriageInfo={{
              carriage_map_id:
              '3',
              carriage_title:
              'GRS-014-01',
              order_number:
              1,
              seats: Array(200).fill(0).map((_, i) => ({
                seat_number: i,
                status: 'available',
                seat_class: 'I Class',
                seat_class_id: 1,
                seat_group_property_id: null,
                seat_group_property_item_id: null,
              })),
            }}
            chosenSeats={[]}
          />
        ) : null
      }
        </div>
      </div>
    </TicketBookingProvider>
  );
}

export default Wagons;
